import { render, staticRenderFns } from "./StarRatingView.vue?vue&type=template&id=8232c3de&scoped=true"
import script from "./StarRatingView.vue?vue&type=script&lang=js"
export * from "./StarRatingView.vue?vue&type=script&lang=js"
import style0 from "./StarRatingView.vue?vue&type=style&index=0&id=8232c3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8232c3de",
  null
  
)

export default component.exports